/**
 * Created by lu on 2017/8/7.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: nb.Model,
    mapping: {},
    method: {
        init: function () {
            // nb.model.onChange(nb.opts.clientReady, function () {
            //     // var screenWidth = document.documentElement.clientWidth;
            //     // var screenHeight = document.documentElement.clientHeight;
            //     // var ImgWitch = (screenWidth - 32)/3;
            //     // var ImgHeight = (screenWidth - 32)/3;
            //     // this.setOpts({
            //     //     imgWitch:ImgWitch,
            //     //     imgHeight:ImgHeight
            //     // })
            // }, this);
        }

    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/uploadImg/ImgItem.js
// module id = 89
// module chunks = 3 4 8 19 29